export interface FinanceState {
  balances:BalanceItem[],
  overdrafts:OverdraftItem[],
}

export interface BalanceFilter {
  date_from?:string,
  date_to?:string,
  partner?:string,
  source?:string,
}

export interface BalanceItem {
  event_date?:string,
  partner?:string,
  amount:number,
  source:string,
  system_user?:string,
  description?:string,
}

export class BalanceItemImpl implements BalanceItem {
  amount:number;
  source:string;

  constructor() {
    this.amount = 0;
    this.source = '';
  }
}

export interface OverdraftFilter {
  partner?:string,
}

export interface OverdraftItem {
  partner?:string,
  balance?:number,
  overdraft:number,
}

export class OverdraftItemImpl implements OverdraftItem {
  overdraft:number;

  constructor() {
    this.overdraft = 0;
  }
}